import { useState } from "react";
import { toast } from "sonner";
import { Send, Wand2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { REQ_KINDS } from "@/components/privacy/privacyConst";

const TPLS = { ...REQ_KINDS, rifiuto: "Rifiuto motivato" };

export const ResponseComposer = ({ req, onSent }) => {
  const [tpl, setTpl] = useState(req.kind);
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const prepare = async () => {
    try { const r = await api.get(`/privacy/requests/${req.id}/draft`, { params: { template: tpl } }); setD(r.data); } catch (e) { toast.error(errMsg(e)); }
  };
  const send = async () => {
    if (!window.confirm(`Inviare la risposta a ${d.to} e chiudere la richiesta come ${d.status}?`)) return;
    setBusy(true);
    try { await api.post(`/privacy/requests/${req.id}/send`, { to: d.to, subject: d.subject, body: d.body, status: d.status }); toast.success(`Risposta inviata a ${d.to}`); setD(null); onSent(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const pending = d && /\[[^\]]*\]/.test(d.body);
  return (
    <div className="mt-6 border bg-muted/30 p-4" data-testid="response-composer">
      <div className="micro-label mb-3">Rispondi all'interessato</div>
      <div className="flex flex-wrap gap-2">
        <Select value={tpl} onValueChange={setTpl}>
          <SelectTrigger className="w-56 bg-white" data-testid="response-template-select"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(TPLS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <Button variant="outline" onClick={prepare} data-testid="response-prepare-button"><Wand2 className="mr-1 h-4 w-4" />Prepara risposta</Button>
      </div>
      {d && <div className="mt-4 space-y-3">
        <div><Label className="micro-label">A (email dell'interessato)</Label><Input className="mt-1 bg-white" value={d.to} onChange={(e) => setD({ ...d, to: e.target.value })} placeholder="Indirizzo email" data-testid="response-to" /></div>
        <div><Label className="micro-label">Oggetto</Label><Input className="mt-1 bg-white" value={d.subject} onChange={(e) => setD({ ...d, subject: e.target.value })} data-testid="response-subject" /></div>
        <div><Label className="micro-label">Testo (mittente: {d.from_name || "gruppo"})</Label><Textarea className="mt-1 bg-white font-mono text-xs" rows={14} value={d.body} onChange={(e) => setD({ ...d, body: e.target.value })} data-testid="response-body" /></div>
        {pending && <p className="text-xs font-semibold text-amber-700" data-testid="response-pending-warning">Completa o elimina le parti tra parentesi quadre prima di inviare.</p>}
        <div className="flex flex-wrap items-center gap-2">
          <Select value={d.status} onValueChange={(v) => setD({ ...d, status: v })}>
            <SelectTrigger className="w-48 bg-white" data-testid="response-status-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="evasa">Chiudi come evasa</SelectItem><SelectItem value="respinta">Chiudi come respinta</SelectItem></SelectContent>
          </Select>
          <Button onClick={send} disabled={busy || pending || !d.to.trim()} data-testid="response-send-button"><Send className="mr-1 h-4 w-4" />{busy ? "Invio…" : "Invia e chiudi"}</Button>
        </div>
      </div>}
    </div>
  );
};
